export type BrowserEventChannelAddress = {
  type: string
  value: unknown
}

export type BrowserEvent<TArguments extends unknown[]> = {
  readonly receiver: string
  readonly method: string
  readonly channel?: BrowserEventChannelAddress
  readonly __arguments?: TArguments
}

export function browserEvent<TArguments extends unknown[]>(
  receiver: string,
  method: string,
  channel?: BrowserEventChannelAddress,
): BrowserEvent<TArguments> {
  return { receiver, method, channel }
}

export function browserEventChannel(type: string, value: unknown): BrowserEventChannelAddress {
  return { type, value }
}

export function browserEventKey(event: BrowserEvent<unknown[]>): string {
  return `${event.receiver}:${event.method}:${event.channel ? browserEventChannelKey(event.channel) : ''}`
}

export function browserEventChannelKey(channel: BrowserEventChannelAddress): string {
  return `${channel.type}:${stableStringify(channel.value)}`
}

export type BrowserEventArguments<TEvent> =
  TEvent extends BrowserEvent<infer TArguments> ? TArguments : never

function stableStringify(value: unknown): string {
  if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'undefined'
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`
  const record = value as Record<string, unknown>
  return `{${Object.keys(record)
    .sort()
    .map((key) => `${JSON.stringify(key)}:${stableStringify(record[key])}`)
    .join(',')}}`
}
